<template>
    <v-container :fluid="true">
        <h2 class="mb-4">System Tools</h2>

        <v-row>
            <v-col cols="12" md="3">
                <v-card elevation="2">
                    <v-list density="compact" nav mandatory v-model:selected="selectedTool" color="primary">
                        <v-list-item v-for="tool in tools" :key="tool.id" :value="tool.id"
                                     :prepend-icon="tool.icon" :title="tool.title" :subtitle="tool.subtitle"/>
                    </v-list>
                </v-card>
            </v-col>

            <v-col cols="12" md="9">
                <v-card elevation="2" class="pa-6">
                    <component :is="activeComponent"/>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import {ref, computed} from 'vue';
import RecalculateSubscriptions from '@/components/system-tools/RecalculateSubscriptions.vue';

const tools = [
    {
        id: 'recalculate-subscriptions',
        title: 'Recalculate Subscriptions',
        subtitle: 'Device subscription end dates',
        icon: 'mdi-refresh',
        component: RecalculateSubscriptions,
    },
];

const selectedTool = ref([tools[0].id]);

const activeComponent = computed(() => {
    const tool = tools.find(t => t.id === selectedTool.value[0]);
    return tool?.component || null;
});
</script>
